import { __decorate, __metadata } from "tslib";
import { lazyAppContextConsumer } from '@1inch-community/core/lazy';
import { subscribe } from '@1inch-community/core/lit-utils';
import { getChainIdList } from '@1inch-community/sdk/chain';
import '@1inch-community/ui-components/icon';
import '@1inch-community/ui-components/number-animation';
import { Task } from '@lit/task';
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { tap } from 'rxjs';
import { tooltip } from '../../tooltip';
const allChainIds = getChainIdList();
let WalletTotalFiatBalanceElement = class WalletTotalFiatBalanceElement extends LitElement {
    constructor() {
        super(...arguments);
        this.chainIds = allChainIds;
        this.applicationContext = lazyAppContextConsumer(this);
        this.task = new Task(this, async ([address, chainIds]) => {
            if (!address)
                throw new Error('');
            return await this.applicationContext.value.tokenStorage.getCrossChainTotalFiatBalance({
                walletAddress: address,
                chainIds: chainIds || null,
            });
        }, () => [this.address, this.chainIds]);
    }
    static { this.tagName = 'inch-wallet-total-fiat-balance'; }
    static { this.styles = css `
    :host {
      display: flex;
      gap: 8px;
      align-items: center;
      position: relative;
    }

    .alert {
      opacity: 0;
      margin-left: -24px;
      transform: translateX(-100%);
      transition:
        transform 0.2s,
        margin-left 0.2s,
        opacity 0.2s;
      transition-delay: 1s;
      pointer-events: none;
    }

    .alert_show {
      position: static;
      margin-left: 0;
      transform: translateX(0);
      opacity: 1;
      pointer-events: all;
    }
  `; }
    firstUpdated() {
        subscribe(this, [
            this.applicationContext.value.onChain.crossChainEmitter.pipe(tap(() => this.task.run([this.address, this.chainIds]))),
        ], { requestUpdate: false });
    }
    render() {
        return this.task.render({
            pending: () => this.renderBalanceOrLoader(),
            error: () => this.renderBalanceOrLoader(),
            complete: () => this.renderBalanceOrLoader(),
        });
    }
    renderBalanceOrLoader() {
        if (!this.task.value)
            return this.renderLoader();
        return this.renderBalance(this.task.value);
    }
    renderBalance(balance) {
        const classes = {
            alert: true,
            alert_show: this.chainIds.length !== allChainIds.length,
        };
        return html `
      <inch-number-animation
        ${tooltip(`$${balance.toFixedSmart(9)}`)}
        .value="${balance.toFixedSmart(2)}"
        prefixSymbol="$"
      ></inch-number-animation>
      <inch-icon
        ${tooltip({ text: 'Some networks are hidden' })}
        class="${classMap(classes)}"
        icon="info16"
      ></inch-icon>
    `;
    }
    renderLoader() {
        return html `<inch-loader-skeleton></inch-loader-skeleton>`;
    }
};
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], WalletTotalFiatBalanceElement.prototype, "address", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", Array)
], WalletTotalFiatBalanceElement.prototype, "chainIds", void 0);
WalletTotalFiatBalanceElement = __decorate([
    customElement(WalletTotalFiatBalanceElement.tagName)
], WalletTotalFiatBalanceElement);
export { WalletTotalFiatBalanceElement };
//# sourceMappingURL=wallet-total-fiat-balance.element.js.map